import React from 'react';
import { Box, Typography } from '@mui/material';

import { formatOfficialDateBR } from '../utils/officialDate';

export interface VerDetalhesComDataPublicacaoProps {
  /** Data da publicação (published_at ou date). Exibida ao lado do controle "Ver detalhes". */
  dataPublicacao?: string | null;
  /** Conteúdo da célula de ações (botão/link "Ver detalhes" ou ActionCell). */
  children: React.ReactNode;
}

const formatarData = (value: string | null | undefined): string | null => {
  if (!value) return null;
  const formatted = formatOfficialDateBR(value);
  return formatted || null;
};

/**
 * Componente reutilizável para a coluna Ações: exibe a data da publicação
 * e o controle "Ver detalhes" (botão ou menu de ações).
 * Usado na lista do Dashboard e na tabela de Mudanças.
 */
export function VerDetalhesComDataPublicacao({
  dataPublicacao,
  children,
}: VerDetalhesComDataPublicacaoProps) {
  const dataFormatada = formatarData(dataPublicacao);

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="flex-end"
      gap={1}
      flexWrap="nowrap"
    >
      {dataFormatada && (
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ whiteSpace: 'nowrap' }}
        >
          {dataFormatada}
        </Typography>
      )}
      {children}
    </Box>
  );
}
